import {
  FullPresetsModel,
  mediaPreset,
  publicConfig,
  stringService,
  urlService,
} from '../../services';
import { ImageResourceModel, SeoModel } from '../../models';
import { getSvgSrc } from '../../features';
import { getCountry } from '../headOrganizationMeta';
import React, { ReactElement } from 'react';
import { MetaOpenGraphTags } from './headOpenGraphMeta.model';
import { NextRouter } from 'next/router';

export const getSeoImage = (
  mediaPresets?: FullPresetsModel,
  imageResource?: ImageResourceModel
): string => {
  if (mediaPresets && imageResource) {
    const isSvg = imageResource?.filename?.slice(-4) === '.svg' || false;

    switch (true) {
      case isSvg:
        return getSvgSrc(imageResource);
      default:
        const imageSet = mediaPreset.getImageSet(
          mediaPresets['seoImageBig'],
          imageResource
        );

        return imageSet?._1x || '';
    }
  }

  return '';
};

export const getSiteDescription = () => {
  switch (publicConfig.APP_NAME) {
    case 'lerna':
      return `Маркетплейс онлайн-курсов ${publicConfig.APP_NAME.toUpperCase()}.${publicConfig.REGION.toLowerCase()}`;
    default:
      return `Онлайн курсы ${stringService.capitalizeFirstLetter(
        publicConfig.APP_NAME
      )} в ${getCountry()}`;
  }
};

export const buildTags = (
  router: NextRouter,
  seo?: SeoModel,
  mediaPresets?: FullPresetsModel
): ReactElement[] => {
  const pageTitle =
    seo?.h1 ||
    seo?.title ||
    stringService.capitalizeFirstLetter(publicConfig.APP_NAME);
  const pageImage = seo?.image
    ? getSeoImage(mediaPresets, seo.image.imageResource)
    : urlService.getUrlToFile('/logo.svg');

  return [
    <meta
      key={MetaOpenGraphTags.title}
      property={MetaOpenGraphTags.title}
      content={pageTitle}
    />,
    <meta
      key={MetaOpenGraphTags.description}
      property={MetaOpenGraphTags.description}
      content={seo?.description}
    />,
    <meta
      key={MetaOpenGraphTags.type}
      property={MetaOpenGraphTags.type}
      content="website"
    />,
    <meta
      key={MetaOpenGraphTags.url}
      property={MetaOpenGraphTags.url}
      content={urlService.getFullUrlToPage(router.asPath, router)}
    />,
    <meta
      key={MetaOpenGraphTags.image}
      property={MetaOpenGraphTags.image}
      content={pageImage}
    />,
    <meta
      key={MetaOpenGraphTags.site}
      property={MetaOpenGraphTags.site}
      content={getSiteDescription()}
    />,
  ];
};
